import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetBalanceStateRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getBalanceState = async (
  instance: AxiosInstance,
  params: DefaultApiGetBalanceStateRequest
) => {
  return await userApiDefaultApiFactory(instance).getBalanceState(params)
}

// Do Not Remove this line ===@import api client===
